/* Seçilebilir yazı tipleri — tasarım belgesi (design.ts) ve blok şeması
   (blocks.ts) ikisi de kullanıyor. Ayrı bir dosyada, çünkü o iki modül
   birbirini içe aktarıyor ve modül yüklenirken `FONTS`'a erişen taraf,
   döngüde önce yüklenirse `undefined` görüyordu (Worker açılışta
   "Cannot convert undefined or null to object" ile düşüyordu). */

/**
 * Seçilebilir yazı tipleri — hepsi Google Fonts'ta, hepsi Türkçe karakter
 * taşıyor. Listenin dışı kabul edilmiyor: CSS'e serbest metin girmesin, ve
 * site CSP'si yalnızca fonts.googleapis.com'a izin veriyor.
 *
 * `axes` Google Fonts css2 adresinin ağırlık kısmı.
 */
export const FONTS = {
  'Bodoni Moda': { role: 'display', axes: 'ital,opsz,wght@0,6..96,400;0,6..96,500;0,6..96,700;0,6..96,900;1,6..96,400;1,6..96,700', fallback: 'serif' },
  'Playfair Display': { role: 'display', axes: 'ital,wght@0,400;0,600;0,800;1,400;1,600', fallback: 'serif' },
  'Cormorant Garamond': { role: 'display', axes: 'ital,wght@0,400;0,500;0,700;1,400;1,500', fallback: 'serif' },
  'DM Serif Display': { role: 'display', axes: 'ital@0;1', fallback: 'serif' },
  'Libre Caslon Display': { role: 'display', axes: 'wght@400', fallback: 'serif' },
  Italiana: { role: 'display', axes: 'wght@400', fallback: 'serif' },
  Syne: { role: 'display', axes: 'wght@400;600;800', fallback: 'sans-serif' },
  Inter: { role: 'body', axes: 'wght@300;400;500;600', fallback: 'sans-serif' },
  Manrope: { role: 'body', axes: 'wght@300;400;500;600', fallback: 'sans-serif' },
  'DM Sans': { role: 'body', axes: 'ital,wght@0,300;0,400;0,500;0,600;1,400', fallback: 'sans-serif' },
  'Work Sans': { role: 'body', axes: 'wght@300;400;500;600', fallback: 'sans-serif' },
  'IBM Plex Sans': { role: 'body', axes: 'ital,wght@0,300;0,400;0,500;0,600;1,400', fallback: 'sans-serif' },
  Karla: { role: 'body', axes: 'wght@300;400;500;600', fallback: 'sans-serif' }
} as const;

export type FontName = keyof typeof FONTS;

/** Sitenin bugünkü yazı tipleri; seçilmediklerinde ek yükleme yapılmıyor. */
export const DEFAULT_FONTS = { display: 'Bodoni Moda', body: 'Inter' } as const;
